(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bar-spotlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPbsFade() {
      const sections = document.querySelectorAll('[data-pbs-section]');
      if (!sections.length) return;

      if (!('IntersectionObserver' in window)) {
        sections.forEach(s => s.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });

      sections.forEach(s => observer.observe(s));
    }

    document.addEventListener('DOMContentLoaded', initPbsFade);
    document.addEventListener('shopify:section:load', initPbsFade);
    initPbsFade();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    var shipEl = document.querySelector('[data-cart-ship]');
    var FREE_SHIPPING_CENTS = ((shipEl && parseInt(shipEl.dataset.freeShipping)) || 499) * 100;
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;

    function fmt(cents) {
      return (cents / 100).toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace('.', ',') + ' kr';
    }

    function updateShippingBar(subtotal) {
      var shipText = document.querySelector('[data-cart-ship-text]');
      var shipFill = document.querySelector('[data-cart-ship-fill]');
      var shipBg = document.querySelector('[data-cart-ship-bg]');
      if (!shipText || !shipFill) return;

      var pct = Math.min(100, Math.round(subtotal / FREE_SHIPPING_CENTS * 100));
      shipFill.style.width = pct + '%';
      if (shipBg) shipBg.style.transform = 'scaleX(' + (pct / 100) + ')';

      if (subtotal >= FREE_SHIPPING_CENTS) {
        shipFill.classList.add('is-done');
        shipText.classList.add('is-done');
        shipText.innerHTML = (shipEl && shipEl.dataset.tFreeHtml) || '<strong>Gratis fragt aktiveret.</strong> Tillykke!';
      } else {
        shipFill.classList.remove('is-done');
        shipText.classList.remove('is-done');
        var remaining = ((FREE_SHIPPING_CENTS - subtotal) / 100).toLocaleString('da-DK', { minimumFractionDigits: 0 });
        shipText.innerHTML = ((shipEl && shipEl.dataset.tRemainingHtml) || '[amount] kr fra <strong>gratis fragt</strong>').replace('[amount]', remaining);
      }
    }

    var sxRemoving = false;
    var sxPrevOpen = null;
    // #4: kort fejring naar man lige har krydset beløbsgrænsen
    function celebrateReward(el) {
      if (!el) return;
      el.classList.remove('is-unlock');
      void el.offsetWidth; // reflow saa animationen kan genstarte
      el.classList.add('is-unlock');
      setTimeout(function () { el.classList.remove('is-unlock'); }, 1100);
    }
    function updateSamples(subtotal) {
      // Re-query hver gang, saa funktionen ogsaa virker efter en section-swap (#3)
      var sxEl = document.querySelector('[data-samples]');
      var sxRewardEl = document.querySelector('[data-sx-reward]');
      var sxRewardText = document.querySelector('[data-sx-reward-text]');
      if (!sxEl && !sxRewardEl) return;
      var threshold = (sxEl && parseInt(sxEl.dataset.sxThreshold, 10)) || (sxRewardEl && parseInt(sxRewardEl.dataset.sxThreshold, 10)) || 0;
      var open = subtotal >= threshold;
      if (sxEl) sxEl.classList.toggle('is-open', open);

      var hasSample = !!document.querySelector('.pc-cart__item--sample');

      // #4: fejr KUN naar subtotalen krydser beløbsgrænsen (laast -> aabnet). Ikke ved foerste load,
      // og ikke naar man tilføjer/fjerner et sample (det aendrer ikke subtotalen, da prøven er 0 kr).
      if (sxPrevOpen === false && open && sxRewardEl) {
        celebrateReward(sxRewardEl);
      }
      sxPrevOpen = open;

      // Belønnings-strip i oversigten (konverterende nudge / unlocked bekræftelse)
      if (sxRewardEl && sxRewardText) {
        if (hasSample) {
          sxRewardEl.classList.add('is-done');
          sxRewardText.innerHTML = sxRewardEl.dataset.tAdded || 'Dit gratis sample er lagt i kurven.';
        } else if (open) {
          sxRewardEl.classList.add('is-done');
          sxRewardText.innerHTML = sxRewardEl.dataset.tUnlocked || 'Gratis sample låst op. Vælg dit nedenfor.';
        } else {
          sxRewardEl.classList.remove('is-done');
          var rem = Math.max(0, threshold - subtotal);
          var rk = (rem / 100).toLocaleString('da-DK', { minimumFractionDigits: 0 });
          sxRewardText.innerHTML = (sxRewardEl.dataset.tRemainingHtml || 'Du er <strong>[amount] kr</strong> fra et gratis sample, du selv vælger.').replace('[amount]', rk);
        }
      }

      // Under graensen: fjern gratis smagsprøve(r) der allerede ligger i kurven, saa man ikke faar dem uden at kvalificere
      if (!open && !sxRemoving) {
        var sampleLines = document.querySelectorAll('.pc-cart__item--sample[data-key]');
        if (sampleLines.length) {
          sxRemoving = true;
          sampleLines.forEach(function (line) {
            var key = line.getAttribute('data-key');
            if (key) changeQty(key, 0, line);
          });
          setTimeout(function () { sxRemoving = false; }, 600);
        }
      }
    }

    function renderCart(cart) {
      // Update count
      var countEl = document.querySelector('[data-cart-line-count]');
      if (countEl) {
        countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' vare' : ' varer');
      }
      // Update subtotal
      var subtotalEl = document.querySelector('[data-cart-subtotal]');
      if (subtotalEl) subtotalEl.textContent = fmt(cart.total_price);
      // Update shipping bar
      updateShippingBar(cart.total_price);
      // Update smagsprøve-selector (slide ud/ind ved beløbsgrænse)
      updateSamples(cart.total_price);
      // Dispatch global event for header cart count + dropdown
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      // If empty, reload to show empty state
      if (cart.item_count === 0) {
        window.location.reload();
      }
    }

    function changeQty(key, qty, itemEl) {
      if (itemEl) itemEl.classList.add('is-updating');
      var wasSample = itemEl && itemEl.classList.contains('pc-cart__item--sample');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function(r) { if (!r.ok) throw new Error('change'); return r.json(); })
      .then(function(cart) {
        // Naar et sample fjernes: gen-render kurv-sektionen (uden reload-blink) saa selectoren viser vælg-griddet igen
        if (wasSample && qty === 0) {
          refreshCartSection();
          return;
        }
        // Update quantity in DOM
        if (itemEl) {
          var qtyVal = itemEl.querySelector('.pc-cart__qty-val');
          if (qtyVal && qty > 0) qtyVal.textContent = qty;

          if (qty === 0) {
            itemEl.style.transition = 'opacity 0.3s, max-height 0.4s, padding 0.4s, margin 0.4s';
            itemEl.style.overflow = 'hidden';
            itemEl.style.maxHeight = itemEl.offsetHeight + 'px';
            requestAnimationFrame(function() {
              itemEl.style.opacity = '0';
              itemEl.style.maxHeight = '0';
              itemEl.style.padding = '0';
              itemEl.style.margin = '0';
            });
            setTimeout(function() { itemEl.remove(); }, 400);
          } else {
            // Update line price by finding item in cart
            var updated = cart.items.find(function(i) { return i.key === key; });
            if (updated) {
              var priceEl = itemEl.querySelector('.pc-cart__item-price');
              if (priceEl) priceEl.textContent = fmt(updated.line_price);
            }
            itemEl.classList.remove('is-updating');
          }
        }
        renderCart(cart);
      })
      .catch(function() {
        // Netvaerks-/serverfejl: laas op igen saa kunden kan proeve igen, og genindlaes korrekt tilstand
        if (itemEl) itemEl.classList.remove('is-updating');
        window.location.reload();
      });
    }

    // #3: gen-render hele kurv-sektionen server-side (ingen reload-blink), med reload som fallback
    function refreshCartSection() {
      var root = document.querySelector('[data-cart-section-id]');
      var id = root ? root.dataset.cartSectionId : null;
      if (!id) { window.location.reload(); return; }
      fetch('/cart?sections=' + encodeURIComponent(id), { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('sec'); return r.json(); })
        .then(function (data) {
          var html = data[id];
          var wrapper = document.getElementById('shopify-section-' + id);
          if (!html || !wrapper) { window.location.reload(); return; }
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('#shopify-section-' + id) || tmp.firstElementChild;
          wrapper.innerHTML = fresh ? fresh.innerHTML : html;
          // gen-synk dynamisk tilstand paa den nye DOM (reward-tekst, shipping-bar, sample-open)
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            updateShippingBar(cart.total_price);
            updateSamples(cart.total_price);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          });
        })
        .catch(function () { window.location.reload(); });
    }

    // Tilføj gratis sample (skjult property _sample). Glider ind via section-swap (#3)
    function addSample(btn) {
      var id = btn.dataset.variant;
      if (!id || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      var lbl = btn.querySelector('span');
      var orig = lbl ? lbl.textContent : '';
      if (lbl) lbl.textContent = (btn.closest('[data-samples]') && btn.closest('[data-samples]').dataset.tAdding) || 'Tilføjer...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1, properties: { _sample: '1' } })
      })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { refreshCartSection(); })
      .catch(function () { btn.classList.remove('is-loading'); if (lbl) lbl.textContent = orig; });
    }

    // Luk alle aabne ristegrad-popups
    function sxCloseAllPops() {
      document.querySelectorAll('[data-sx-pop].is-open').forEach(function (pop) {
        pop.classList.remove('is-open');
        setTimeout(function () { if (!pop.classList.contains('is-open')) pop.hidden = true; }, 280);
      });
    }

    // Event-delegation paa document: overlever section-swaps, saa intet skal re-bindes
    document.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('[data-cart-qty]');
      if (qtyBtn) {
        var qItem = qtyBtn.closest('[data-cart-item]');
        if (qItem) {
          var qtyEl = qItem.querySelector('.pc-cart__qty-val');
          var cur = qtyEl ? parseInt(qtyEl.textContent) : 1;
          var next = Math.max(0, cur + parseInt(qtyBtn.dataset.cartQty));
          changeQty(qItem.dataset.key, next, qItem);
        }
        return;
      }
      var rmBtn = e.target.closest('[data-cart-remove]');
      if (rmBtn) {
        var rItem = rmBtn.closest('[data-cart-item]');
        if (rItem) changeQty(rItem.dataset.key, 0, rItem);
        return;
      }
      var addBtn = e.target.closest('[data-sx-add]');
      if (addBtn) { e.preventDefault(); addSample(addBtn); return; }
      var openBtn = e.target.closest('[data-sx-open]');
      if (openBtn) {
        e.preventDefault();
        var card = openBtn.closest('.pc-sx__card');
        var pop = card ? card.querySelector('[data-sx-pop]') : null;
        if (pop) {
          var willOpen = !pop.classList.contains('is-open');
          sxCloseAllPops();
          if (willOpen) {
            pop.hidden = false;
            requestAnimationFrame(function () { pop.classList.add('is-open'); });
          }
        }
        return;
      }
      if (e.target.closest('[data-sx-close]')) { e.preventDefault(); sxCloseAllPops(); return; }
      // klik udenfor et kort lukker popups
      if (!e.target.closest('.pc-sx__card')) sxCloseAllPops();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') sxCloseAllPops();
    });

    // Initial tilstand: server-renderet subtotal for at undgaa flicker, derefter live fra /cart.js
    var sxElInit = document.querySelector('[data-samples]');
    if (sxElInit) {
      var sxInit = parseInt(sxElInit.dataset.sxSubtotal, 10);
      if (!isNaN(sxInit)) updateSamples(sxInit);
    }
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      updateShippingBar(cart.total_price);
      updateSamples(cart.total_price);
    });
  })();

  // Upsell: ristegrad-valg + laeg 250g i kurv (ingen popup)
  (function () {
    function fmtKr(cents) {
      return (cents / 100).toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace('.', ',') + ' kr';
    }

    document.querySelectorAll('[data-up-card]').forEach(function (card) {
      var roasts = card.querySelectorAll('[data-up-roast]');
      var addBtn = card.querySelector('[data-up-add]');
      var priceEl = card.querySelector('[data-up-price]');
      if (!addBtn) return;

      // Overflow-pil: vis kun naar der er flere ristegrader end der er plads til
      var rWrap = card.querySelector('[data-up-roasts-wrap]');
      var rScroll = card.querySelector('[data-up-roasts]');
      var rArrow = card.querySelector('[data-up-roasts-arrow]');
      if (rWrap && rScroll) {
        var updateArrow = function () {
          var canScroll = rScroll.scrollWidth - rScroll.clientWidth > 2;
          rWrap.classList.toggle('is-scrollable', canScroll);
          var atEnd = rScroll.scrollLeft + rScroll.clientWidth >= rScroll.scrollWidth - 2;
          rWrap.classList.toggle('is-end', atEnd);
        };
        updateArrow();
        rScroll.addEventListener('scroll', updateArrow, { passive: true });
        window.addEventListener('resize', updateArrow);
        if (rArrow) {
          rArrow.addEventListener('click', function () {
            rScroll.scrollBy({ left: Math.round(rScroll.clientWidth * 0.7), behavior: 'smooth' });
          });
        }
      }

      roasts.forEach(function (r) {
        r.addEventListener('click', function () {
          if (r.classList.contains('is-disabled')) return;
          roasts.forEach(function (x) { x.classList.remove('is-active'); });
          r.classList.add('is-active');
          addBtn.dataset.variant = r.dataset.variant;
          if (priceEl && r.dataset.price) priceEl.textContent = fmtKr(parseInt(r.dataset.price, 10));
        });
      });

      addBtn.addEventListener('click', async function () {
        if (addBtn.classList.contains('is-loading') || addBtn.classList.contains('is-added')) return;
        var id = addBtn.dataset.variant;
        if (!id) return;
        var txt = addBtn.querySelector('.pc-up__add-txt');
        var orig = txt ? txt.textContent : '';
        addBtn.classList.add('is-loading');
        var upRoot = addBtn.closest('[data-upsell]');
        if (txt) txt.textContent = (upRoot && upRoot.dataset.tAdding) || 'Tilføjer...';

        try {
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: id, quantity: 1 })
          });
          if (!res.ok) throw new Error('add failed');
          var cart = await (await fetch('/cart.js')).json();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          addBtn.classList.remove('is-loading');
          addBtn.classList.add('is-added');
          if (txt) txt.textContent = (upRoot && upRoot.dataset.tAdded) || '250 g tilføjet';

          // Laekker "flyvende 250g" animation mod kurven i headeren
          flyToCart(card);

          setTimeout(function () { window.location.reload(); }, 950);
        } catch (e) {
          addBtn.classList.remove('is-loading');
          if (txt) txt.textContent = orig;
        }
      });
    });

    // Flyvende billede fra kort mod kurv-ikonet i headeren
    function flyToCart(card) {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var img = card.querySelector('.pc-up__media img');
      var target = document.querySelector('#ph-cart-wrap .ph__cart, .ph__cart, [data-cart-count]');
      if (!img || !target) return;

      var imgRect = img.getBoundingClientRect();
      var tRect = target.getBoundingClientRect();

      var fly = img.cloneNode(true);
      fly.style.position = 'fixed';
      fly.style.left = imgRect.left + 'px';
      fly.style.top = imgRect.top + 'px';
      fly.style.width = imgRect.width + 'px';
      fly.style.height = imgRect.height + 'px';
      fly.style.borderRadius = '8px';
      fly.style.objectFit = 'cover';
      fly.style.zIndex = '99999';
      fly.style.pointerEvents = 'none';
      fly.style.transition = 'all 0.85s cubic-bezier(0.5, -0.2, 0.3, 1)';
      fly.style.opacity = '1';
      document.body.appendChild(fly);

      // Force reflow saa transition fyrer
      fly.getBoundingClientRect();

      var endX = tRect.left + tRect.width / 2 - 18;
      var endY = tRect.top + tRect.height / 2 - 18;
      fly.style.left = endX + 'px';
      fly.style.top = endY + 'px';
      fly.style.width = '36px';
      fly.style.height = '36px';
      fly.style.opacity = '0.2';
      fly.style.transform = 'rotate(8deg)';

      setTimeout(function () { fly.remove(); }, 900);

      // Lille puls paa kurv-ikonet naar varen "lander"
      setTimeout(function () {
        target.classList.add('ph__cart--bump');
        setTimeout(function () { target.classList.remove('ph__cart--bump'); }, 400);
      }, 700);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Free shipping bar, 1:1 fra live
  (function(){
    var SHIP_THRESHOLD = 49900;
    var shipText = document.getElementById('pcc-ship-text');
    var shipFill = document.getElementById('pcc-ship-fill');
    var shipBg   = document.getElementById('pcc-ship-bg');

    function updateShippingBar(subtotal){
      if(!shipText || !shipFill) return;
      var pct = Math.min(100, Math.round(subtotal / SHIP_THRESHOLD * 100));
      shipFill.style.width = pct + '%';
      if(shipBg) shipBg.style.transform = 'scaleX(' + (pct / 100) + ')';
      if(subtotal >= SHIP_THRESHOLD){
        shipFill.classList.add('is-done');
        shipText.classList.add('is-done');
        shipText.innerHTML = shipText.dataset.tFreeHtml || '<strong>Gratis fragt aktiveret.</strong> Tillykke!';
      } else {
        shipFill.classList.remove('is-done');
        shipText.classList.remove('is-done');
        var remaining = ((SHIP_THRESHOLD - subtotal) / 100).toLocaleString('da-DK', { minimumFractionDigits: 0 });
        shipText.innerHTML = (shipText.dataset.tRemainingHtml || '[amount] kr fra <strong>gratis fragt</strong>').replace('[amount]', remaining);
      }
    }

    function fetchCart(){
      fetch('/cart.js')
        .then(function(r){ return r.json(); })
        .then(function(cart){ updateShippingBar(cart.total_price); })
        .catch(function(){ if(shipText) shipText.textContent = shipText.dataset.tDefault || 'Gratis fragt ved 499 kr'; });
    }

    fetchCart();
    document.addEventListener('cart:updated', fetchCart);
  })();

  // Land-filtrering (client-side, instant, ingen reload)
  (function () {
    var grid = document.querySelector('[data-pcc-grid]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.ppc__card'));
    if (!cards.length) return;

    var countEl = document.querySelector('[data-pcc-count]');
    var noResults = document.querySelector('[data-pcc-no-results]');
    var chips = Array.prototype.slice.call(document.querySelectorAll('[data-pcc-filter]'));
    var resetBtn = document.querySelector('[data-pcc-reset]');
    var activeCountry = 'all';

    function pluralCount(n) {
      return n + ' ' + (n === 1 ? 'produkt' : 'produkter');
    }

    function apply() {
      var shown = 0;
      cards.forEach(function (card) {
        var ok = activeCountry === 'all' || (card.dataset.country || '') === activeCountry;
        card.hidden = !ok;
        if (ok) shown++;
      });
      if (countEl) countEl.textContent = pluralCount(shown);
      if (noResults) noResults.hidden = shown !== 0;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        activeCountry = chip.dataset.pccFilter;
        apply();
      });
    });

    if (resetBtn) resetBtn.addEventListener('click', function () {
      activeCountry = 'all';
      chips.forEach(function (c) {
        c.classList.toggle('is-active', c.dataset.pccFilter === 'all');
      });
      apply();
    });
  })();

  // Smagsnote-entrance i 2-kolonne mobil-grid: chips glider ind foerste gang
  // kortet rammer viewporten. CSS'en er gated paa .pcc-anim-klar, saa uden JS
  // (eller uden IntersectionObserver) er chips bare synlige som altid.
  (function () {
    var grid = document.querySelector('[data-pcc-grid][data-cols-mobile="2"]');
    if (!grid || !('IntersectionObserver' in window)) return;
    grid.classList.add('pcc-anim-klar');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ppc-inde'); io.unobserve(e.target); }
      });
    }, { threshold: 0.35 });
    grid.querySelectorAll('.ppc__img-wrap').forEach(function (b) { io.observe(b); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var formWrap = document.getElementById('pcFormWrap');
    var emailInput = document.getElementById('pcEmail');
    var btn = document.getElementById('pcNewsBtn');
    var success = document.getElementById('pcSuccess');
    var copyBtn = document.getElementById('pcCopyBtn');
    var submitted = false;

    if (!btn || !emailInput || !formWrap || !success) return;

    function showSuccess() {
      if (submitted) return;
      submitted = true;
      // Marker tilmeldt saa 15%-boblen ikke ogsaa dukker op
      try { localStorage.setItem('pc_news_signed', '1'); } catch (e) {}
      formWrap.style.opacity = '0';
      formWrap.style.transform = 'translateY(-8px)';
      formWrap.style.transition = 'all 0.35s ease';

      setTimeout(function () {
        formWrap.style.display = 'none';
        success.classList.add('pc-footer__success--visible');
      }, 350);
    }

    btn.addEventListener('click', function () {
      if (submitted) return;
      var email = emailInput.value.trim();

      if (!email || !email.includes('@') || !email.includes('.')) {
        emailInput.style.borderColor = 'rgba(245,240,232,0.65)';
        setTimeout(function () { emailInput.style.borderColor = ''; }, 1200);
        return;
      }

      var origLabel = btn.textContent;
      btn.textContent = '...';
      btn.disabled = true;

      function failGracefully() {
        btn.disabled = false;
        btn.textContent = origLabel;
        emailInput.style.borderColor = 'rgba(245,240,232,0.65)';
        emailInput.setAttribute('placeholder', emailInput.dataset.tError || 'Noget gik galt, prøv igen');
        setTimeout(function () { emailInput.style.borderColor = ''; }, 2000);
      }

      var hdr = { 'Content-Type': 'application/x-www-form-urlencoded' };
      var enc = encodeURIComponent;
      // 1) Nyhedsbrev-tilmelding (marketing + tag), sender ikke mail
      var marketing = fetch('/contact', {
        method: 'POST', headers: hdr, redirect: 'manual',
        body: 'form_type=customer&utf8=%E2%9C%93&contact%5Btags%5D=newsletter%2Cfooter&contact%5Bemail%5D=' + enc(email)
      });
      // 2) Kontakt-indsendelse, sender notifikations-mail til butikken (markeret "via footer")
      var notify = fetch('/contact', {
        method: 'POST', headers: hdr, redirect: 'manual',
        body: 'form_type=contact&utf8=%E2%9C%93&contact%5Bemail%5D=' + enc(email) + '&contact%5Bbody%5D=' + enc('Ny tilmelding via footer (nyhedsbrev). Email: ' + email)
      });
      Promise.allSettled([marketing, notify]).then(function (results) {
        var ok = results.some(function (res) {
          return res.status === 'fulfilled' && res.value && (res.value.type === 'opaqueredirect' || res.value.status < 400);
        });
        if (ok) { showSuccess(); } else { failGracefully(); }
      });
    });

    emailInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        btn.click();
      }
    });

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = document.getElementById('pcCode').textContent;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(function () {
            var origCopy = copyBtn.textContent;
            copyBtn.textContent = (copyBtn.dataset.copied || 'Kopieret') + ' ✓';
            setTimeout(function () { copyBtn.textContent = origCopy; }, 2500);
          });
        }
      });
    }
  })();

  /* Cookie-indstillinger: genåbner Shopifys samtykke-banner, så samtykke kan trækkes tilbage lige så let som det gives (2/10-2026) */
  (function () {
    var btn = document.querySelector('[data-cookie-settings]');
    if (!btn) return;
    function aaben() {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
        return true;
      }
      return false;
    }
    btn.addEventListener('click', function () {
      if (aaben()) return;
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
          if (!aaben()) window.location.href = btn.dataset.fallback;
        });
      } else {
        window.location.href = btn.dataset.fallback;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["founder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPabFade() {
      const sections = document.querySelectorAll('[data-pab-section]');
      if (!sections.length) return;

      if (!('IntersectionObserver' in window)) {
        sections.forEach(s => s.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.25 });

      sections.forEach(s => observer.observe(s));
    }

    document.addEventListener('DOMContentLoaded', initPabFade);
    document.addEventListener('shopify:section:load', initPabFade);
    initPabFade();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var dd       = document.getElementById('ph-cart-dd');
    var itemsEl  = document.getElementById('ph-dd-items');
    var footerEl = document.getElementById('ph-dd-footer');
    var totalEl  = document.getElementById('ph-dd-total');
    var countEl  = document.getElementById('ph-cart-count');
    var wrap     = document.getElementById('ph-cart-wrap');
    var hideTimer;

    if (!dd || !wrap) return;

    function fmt(cents){ return (cents/100).toFixed(2).replace('.', ',') + ' kr'; }

    function imgSrc(url){
      if (!url) return '';
      return url.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2');
    }

    // Escape brugerdata foer det indsaettes i innerHTML (defensiv mod XSS)
    function esc(str){
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function openDd(){ dd.classList.add('is-open'); fetchCart(); }
    function closeDd(){ dd.classList.remove('is-open'); }

    wrap.addEventListener('mouseenter', function(){
      if (window.innerWidth < 750) return;
      clearTimeout(hideTimer);
      openDd();
    });
    wrap.addEventListener('mouseleave', function(){
      if (window.innerWidth < 750) return;
      hideTimer = setTimeout(closeDd, 200);
    });
    document.addEventListener('click', function(e){
      if (dd.classList.contains('is-open') && !wrap.contains(e.target)) closeDd();
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape') closeDd();
    });

    function fetchCart(){
      fetch('/cart.js')
        .then(function(r){ if(!r.ok) throw new Error('cart'); return r.json(); })
        .then(renderCart)
        .catch(function(){
          if (itemsEl) itemsEl.innerHTML = '<div class="ph__dd-empty">' + (wrap && wrap.dataset.tErrorHtml ? wrap.dataset.tErrorHtml : 'Kunne ikke hente kurven. <a href="/cart">Gå til kurven</a>') + '</div>';
          if (footerEl) footerEl.style.display = 'none';
        });
    }

    function renderCart(cart){
      var count = cart.item_count;
      countEl.textContent = count;
      countEl.classList.toggle('is-empty', count === 0);
      if (count > 0) {
        countEl.classList.add('bump');
        setTimeout(function(){ countEl.classList.remove('bump'); }, 300);
      }

      if (!cart.items || cart.items.length === 0) {
        itemsEl.innerHTML = '<div class="ph__dd-empty">' + (wrap && wrap.dataset.tEmptyHtml ? wrap.dataset.tEmptyHtml : 'Kurven er tom.<br><a href="/collections/specialty-kaffebonner">Udforsk sortimentet →</a>') + '</div>';
        footerEl.style.display = 'none';
        return;
      }

      var html = '';
      cart.items.forEach(function(item){
        var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
        html +=
          '<div class="ph__dd-item" data-key="' + item.key + '">' +
            '<div class="ph__dd-img"><img src="' + esc(imgSrc(item.image)) + '" alt="' + esc(item.product_title) + '" loading="lazy"></div>' +
            '<div class="ph__dd-info">' +
              '<div class="ph__dd-name">' + esc(item.product_title) + '</div>' +
              (variant ? '<div class="ph__dd-variant">' + esc(variant) + '</div>' : '') +
              '<div class="ph__dd-controls">' +
                '<button class="ph__dd-qty-btn" data-key="' + item.key + '" data-delta="-1" type="button">&#8722;</button>' +
                '<span class="ph__dd-qty-val">' + item.quantity + '</span>' +
                '<button class="ph__dd-qty-btn" data-key="' + item.key + '" data-delta="1" type="button">+</button>' +
                '<button class="ph__dd-remove" data-key="' + item.key + '" type="button" aria-label="' + esc(wrap && wrap.dataset.tRemove ? wrap.dataset.tRemove : 'Fjern') + '">' +
                  '<svg viewBox="0 0 24 24"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"/></svg>' +
                '</button>' +
              '</div>' +
            '</div>' +
            '<div class="ph__dd-price">' + fmt(item.line_price) + '</div>' +
          '</div>';
      });
      itemsEl.innerHTML = html;
      totalEl.textContent = fmt(cart.total_price);
      footerEl.style.display = 'block';

      itemsEl.querySelectorAll('.ph__dd-qty-btn').forEach(function(btn){
        btn.addEventListener('click', function(){
          var key = btn.dataset.key;
          var itemEl = itemsEl.querySelector('[data-key="' + key + '"]');
          var qtyEl = itemEl ? itemEl.querySelector('.ph__dd-qty-val') : null;
          var cur = qtyEl ? parseInt(qtyEl.textContent) : 1;
          var next = Math.max(0, cur + parseInt(btn.dataset.delta));
          if (qtyEl && next > 0) qtyEl.textContent = next;
          if (itemEl) itemEl.classList.add('is-updating');
          changeQty(key, next);
        });
      });

      itemsEl.querySelectorAll('.ph__dd-remove').forEach(function(btn){
        btn.addEventListener('click', function(){
          var key = btn.dataset.key;
          var itemEl = itemsEl.querySelector('[data-key="' + key + '"]');
          if (itemEl) itemEl.classList.add('is-updating');
          changeQty(key, 0);
        });
      });
    }

    function changeQty(key, qty){
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function(r){ if(!r.ok) throw new Error('change'); return r.json(); })
      .then(function(cart){
        renderCart(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function(){ fetchCart(); });
    }

    document.addEventListener('cart:updated', function(e){
      if (e.detail && e.detail.cart) renderCart(e.detail.cart);
      else fetchCart();
    });

    fetchCart();
  })();

  /* Mobile fullscreen menu (matches live 1:1) */
  (function () {
    var burger = document.getElementById('ph-burger');
    var mobile = document.getElementById('ph-mobile');
    var mclose = document.getElementById('ph-mobile-close');
    if (!burger || !mobile) return;

    function focusables() {
      return Array.prototype.slice.call(
        mobile.querySelectorAll('a[href], button:not([disabled])')
      ).filter(function (el) { return el.offsetParent !== null; });
    }

    function openMobile() {
      mobile.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      // Flyt fokus ind i menuen (foerste fokuserbare element)
      var f = focusables();
      if (f.length) f[0].focus();
    }
    function closeMobile() {
      if (!mobile.classList.contains('is-open')) return;
      mobile.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      // Returner fokus til burger-knappen
      burger.focus();
    }

    burger.addEventListener('click', openMobile);
    if (mclose) mclose.addEventListener('click', closeMobile);

    mobile.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeMobile);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMobile();
      // Fokus-faelde: hold Tab inde i menuen mens den er aaben
      if (e.key === 'Tab' && mobile.classList.contains('is-open')) {
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }
    });

    /* Sync mobile cart count when main cart updates */
    var mobileCount = document.getElementById('ph-mobile-count');
    if (mobileCount) {
      document.addEventListener('cart:updated', function (e) {
        if (e.detail && e.detail.cart) {
          mobileCount.textContent = e.detail.cart.item_count > 0 ? e.detail.cart.item_count : '';
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.newsletter__copy').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      try {
        await navigator.clipboard.writeText(btn.dataset.code);
        const orig = btn.textContent;
        btn.textContent = btn.dataset.copied || 'Kopieret';
        setTimeout(() => { btn.textContent = orig; }, 1500);
      } catch {}
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-about"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sec = document.getElementById('op-about');
    if (!sec) return;

    // Fallback: hvis IntersectionObserver mangler (gammel browser/headless),
    // vis alt indhold med det samme saa siden aldrig shipper blankt.
    if (!('IntersectionObserver' in window)) {
      sec.querySelectorAll('[data-op-anim]').forEach(function (el) { el.classList.add('op-in'); });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('op-in');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -30px 0px' });

    sec.querySelectorAll('.op-intro [data-op-anim]').forEach(function (el) {
      var d = parseFloat(el.getAttribute('data-op-delay') || '0');
      el.style.transitionDelay = d + 's';
      obs.observe(el);
    });

    sec.querySelectorAll('.op-text, .op-cta').forEach(function (parent) {
      parent.querySelectorAll('[data-op-anim]').forEach(function (el, i) {
        el.style.transitionDelay = (i * 0.13) + 's';
        obs.observe(el);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFsContact() {
      var root = document.getElementById('fs-contact');
      if (!root || root.dataset.fsInit === '1') return;
      root.dataset.fsInit = '1';

      var els = root.querySelectorAll('[data-fs-anim]');

      if (!('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('fs-in'); });
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('fs-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

      els.forEach(function (el, i) {
        el.style.transitionDelay = (i % 5) * 0.08 + 's';
        io.observe(el);
      });
    }

    document.addEventListener('DOMContentLoaded', initFsContact);
    document.addEventListener('shopify:section:load', initFsContact);
    initFsContact();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.getElementById('op-contact');
    if (!root) return;

    var animEls = root.querySelectorAll('[data-op-anim]');
    var cards = root.querySelectorAll('.op-card');

    if (!('IntersectionObserver' in window)) {
      animEls.forEach(function (el) { el.classList.add('is-in'); });
      cards.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    animEls.forEach(function (el) { io.observe(el); });
    cards.forEach(function (el) { io.observe(el); });

    /* Stagger inside form */
    root.querySelectorAll('.op-form [data-op-anim]').forEach(function (el, i) {
      el.style.transitionDelay = (i * 0.1) + 's';
    });

    /* Subtle parallax on cards via mouse position */
    cards.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = 'translateY(-3px) rotateX(' + (-y * 1.2) + 'deg) rotateY(' + (x * 1.2) + 'deg)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.getElementById('op-faq');
    if (!root) return;

    /* Smooth height animation on accordion toggle */
    var items = root.querySelectorAll('.op-faq__item');
    items.forEach(function (item) {
      var summary = item.querySelector('.op-faq__q');
      var content = item.querySelector('.op-faq__a');
      if (!summary || !content) return;

      function animateOpen() {
        var startHeight = 0;
        var endHeight = content.scrollHeight;
        content.style.height = startHeight + 'px';
        content.style.overflow = 'hidden';
        content.style.transition = 'height 0.42s cubic-bezier(0.22,1,0.36,1)';

        requestAnimationFrame(function () {
          content.style.height = endHeight + 'px';
        });

        content.addEventListener('transitionend', function handler() {
          content.style.height = '';
          content.style.overflow = '';
          content.style.transition = '';
          content.removeEventListener('transitionend', handler);
        });
      }

      function animateClose(then) {
        var startHeight = content.scrollHeight;
        content.style.height = startHeight + 'px';
        content.style.overflow = 'hidden';
        content.style.transition = 'height 0.42s cubic-bezier(0.22,1,0.36,1)';

        requestAnimationFrame(function () {
          content.style.height = '0px';
        });

        content.addEventListener('transitionend', function handler() {
          content.style.height = '';
          content.style.overflow = '';
          content.style.transition = '';
          item.removeAttribute('open');
          content.removeEventListener('transitionend', handler);
          if (then) then();
        });
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (item.hasAttribute('open')) {
          animateClose();
        } else {
          item.setAttribute('open', '');
          animateOpen();
        }
      });
    });

    /* Scroll-in observer */
    var animEls = root.querySelectorAll('[data-faq-anim]');
    var list = root.querySelector('[data-faq-list]');

    if (!('IntersectionObserver' in window)) {
      animEls.forEach(function (el) { el.classList.add('is-in'); });
      if (list) list.classList.add('is-in');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    animEls.forEach(function (el) { io.observe(el); });
    if (list) io.observe(list);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piccolo-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPiccoloReviews() {
      document.querySelectorAll('[data-piccolo-reviews]').forEach(function(section) {
        if (section.dataset.reviewsInitialized === 'true') return;
        section.dataset.reviewsInitialized = 'true';

        var track = section.querySelector('[data-reviews-track]');
        var prev = section.querySelector('[data-reviews-prev]');
        var next = section.querySelector('[data-reviews-next]');
        if (!track || !prev || !next) return;

        function getScrollAmount() {
          var card = track.querySelector('.piccolo-reviews__card');
          if (!card) return 288;
          var style = window.getComputedStyle(track);
          var gap = parseFloat(style.columnGap || style.gap || 18);
          return card.getBoundingClientRect().width + gap;
        }

        next.addEventListener('click', function(e) {
          e.preventDefault();
          track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });
        prev.addEventListener('click', function(e) {
          e.preventDefault();
          track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });
      });
    }

    document.addEventListener('DOMContentLoaded', initPiccoloReviews);
    document.addEventListener('shopify:section:load', initPiccoloReviews);
    initPiccoloReviews();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["policy"]) return;
  try {
    
  (function () {
    var els = document.querySelectorAll('#op-policy [data-policy-anim]');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          entry.target.style.transitionDelay = (i * 0.08) + 's';
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-popup]');
    if (!root) return;

    var card = root.querySelector('[data-bub-card]');
    var box = root.querySelector('[data-bub-box]');
    var openBtn = root.querySelector('[data-bub-open]');
    var collapseEls = root.querySelectorAll('[data-bub-collapse]');
    var dismissEls = root.querySelectorAll('[data-bub-dismiss]');
    var emailInput = root.querySelector('[data-bub-email]');
    var submitBtn = root.querySelector('[data-bub-submit]');
    var formWrap = root.querySelector('[data-bub-form-wrap]');
    var successEl = root.querySelector('[data-bub-success]');
    var copyBtn = root.querySelector('[data-bub-copy]');
    var codeEl = root.querySelector('[data-bub-code]');

    var DELAY = (parseInt(root.getAttribute('data-popup-delay'), 10) || 4) * 1000;
    var DAYS = parseInt(root.getAttribute('data-popup-days'), 10) || 30;
    var CLICKS = parseInt(root.getAttribute('data-popup-clicks'), 10) || 0;
    var AUTO = parseInt(root.getAttribute('data-popup-auto'), 10) || 0;
    var SUBSCRIBED = root.getAttribute('data-subscribed') === '1';
    var DKEY = 'pc_bub_dismissed';
    var SKEY = 'pc_news_signed';
    var CKEY = 'pc_bub_clicks';
    var AKEY = 'pc_bub_autoopened';

    function ls(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function setLs(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
    function ss(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
    function setSs(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

    function shouldHide() {
      if (SUBSCRIBED) return true;
      if (ls(SKEY)) return true;
      var ts = parseInt(ls(DKEY), 10);
      if (ts && (Date.now() - ts) < DAYS * 86400000) return true;
      return false;
    }

    if (shouldHide()) return;

    // ---------- Cookie-banner-gate ----------
    // Shopifys banner ligger som direkte barn af body, id shopify-pc__banner, og faar
    // style="display:none" naar besoegende har valgt (samtidig sendes visitorConsentCollected).
    var ventende = [];
    var gateTjekker = null;
    function bannerSynligt() {
      var b = document.getElementById('shopify-pc__banner');
      if (!b) return false;
      var cs = getComputedStyle(b);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && b.getBoundingClientRect().height > 0;
    }
    function tjekGate() {
      if (bannerSynligt()) { root.classList.add('pc-bub--venter'); return; }
      root.classList.remove('pc-bub--venter');
      if (ventende.length) {
        var fns = ventende.splice(0);
        // Lille pause efter valget, saa boblen ikke smaekker op i samme sekund
        setTimeout(function () { fns.forEach(function (fn) { fn(); }); }, 700);
      }
    }
    function naarBannerVaek(fn) {
      if (!bannerSynligt()) { fn(); return; }
      ventende.push(fn);
      root.classList.add('pc-bub--venter');
    }
    document.addEventListener('visitorConsentCollected', function () { setTimeout(tjekGate, 50); });
    if (window.MutationObserver) {
      var obs = new MutationObserver(tjekGate);
      obs.observe(document.body, { childList: true });
      var bannerObs = null;
      var koblBanner = function () {
        var b = document.getElementById('shopify-pc__banner');
        if (!b || bannerObs) return;
        bannerObs = new MutationObserver(tjekGate);
        bannerObs.observe(b, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
      };
      koblBanner();
      new MutationObserver(koblBanner).observe(document.body, { childList: true });
    }
    // Banneret injiceres asynkront (typisk 1-3 s), saa de foerste 90 s tjekkes ogsaa med interval
    var gateStart = Date.now();
    gateTjekker = setInterval(function () {
      tjekGate();
      if (Date.now() - gateStart > 90000) clearInterval(gateTjekker);
    }, 500);

    function showBubble() {
      root.hidden = false;
      root.getBoundingClientRect();
      root.classList.add('is-ready');
    }
    function openCard() {
      if (card) card.hidden = false;
      root.getBoundingClientRect();
      root.classList.add('is-open');
      // Fokus i feltet kun paa desktop. Paa touch ville det aabne tastaturet
      // automatisk, saa dér flyttes fokus blot ind i kassen uden felt-fokus.
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        if (emailInput) emailInput.focus({ preventScroll: true });
      } else if (box) {
        box.focus({ preventScroll: true });
      }
    }
    function collapseCard() {
      root.classList.remove('is-open');
      setTimeout(function () { if (card) card.hidden = true; }, 480);
      if (openBtn) openBtn.focus({ preventScroll: true });
    }
    function dismissAll() {
      root.classList.remove('is-open', 'is-ready');
      setTimeout(function () { root.hidden = true; }, 450);
      setLs(DKEY, String(Date.now()));
    }

    if (openBtn) openBtn.addEventListener('click', openCard);
    collapseEls.forEach(function (el) { el.addEventListener('click', collapseCard); });
    dismissEls.forEach(function (el) { el.addEventListener('click', dismissAll); });

    // Escape lukker, Tab bliver inde i kassen mens den er aaben
    document.addEventListener('keydown', function (e) {
      if (!root.classList.contains('is-open')) return;
      if (e.key === 'Escape') { collapseCard(); return; }
      if (e.key !== 'Tab' || !box) return;
      var focusable = box.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      var synlige = Array.prototype.filter.call(focusable, function (el) { return el.offsetParent !== null; });
      if (!synlige.length) return;
      var first = synlige[0], last = synlige[synlige.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === box)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    setTimeout(function () { naarBannerVaek(function () { if (!shouldHide()) showBubble(); }); }, DELAY);

    // Auto-aabn kassen: efter X klik paa siden ELLER efter Y sekunder. Sker een gang pr. session.
    // Venter paa cookie-banneret som boblen.
    function autoOpen() {
      if (ss(AKEY)) return;
      if (root.classList.contains('is-open')) return;
      naarBannerVaek(function () {
        if (ss(AKEY) || shouldHide() || root.classList.contains('is-open')) return;
        setSs(AKEY, '1');
        showBubble();
        openCard();
      });
    }

    // 1) Tids-trigger (sekunder efter sidevisning)
    if (AUTO > 0) {
      setTimeout(autoOpen, AUTO * 1000);
    }

    // 2) Klik-trigger (akkumuleres paa tvaers af sider i sessionen)
    if (CLICKS > 0 && !ss(AKEY)) {
      // Hvis taelleren allerede er naaet (fx 5. klik var et link der navigerede), aabn ved load
      if ((parseInt(ss(CKEY), 10) || 0) >= CLICKS) {
        setTimeout(autoOpen, 600);
      }
      document.addEventListener('click', function (e) {
        if (ss(AKEY)) return;
        // Tael ikke klik inde i selve boblen/kassen
        if (root.contains(e.target)) return;
        if (root.classList.contains('is-open')) return;
        var n = (parseInt(ss(CKEY), 10) || 0) + 1;
        setSs(CKEY, String(n));
        if (n >= CLICKS) autoOpen();
      });
    }

    // Tilmelding (samme nyhedsbrev-metode som live: form_type=customer)
    function showSuccess() {
      setLs(SKEY, '1');
      if (formWrap) formWrap.hidden = true;
      if (successEl) successEl.hidden = false;
    }
    function failGracefully(orig) {
      submitBtn.disabled = false;
      var span = submitBtn.querySelector('span');
      if (span) { span.textContent = submitBtn.dataset.tRetry || 'Prøv igen'; setTimeout(function () { span.textContent = orig; }, 2200); }
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        var email = (emailInput.value || '').trim();
        if (!email || email.indexOf('@') === -1 || email.indexOf('.') === -1) {
          emailInput.style.borderColor = 'var(--color-error, #A83232)';
          setTimeout(function () { emailInput.style.borderColor = ''; }, 1400);
          emailInput.focus();
          return;
        }
        var span = submitBtn.querySelector('span');
        var orig = span ? span.textContent : '';
        if (span) span.textContent = '...';
        submitBtn.disabled = true;

        var hdr = { 'Content-Type': 'application/x-www-form-urlencoded' };
        var enc = encodeURIComponent;
        // 1) Nyhedsbrev-tilmelding (marketing-samtykke + tag), sender ikke mail
        var marketing = fetch('/contact', {
          method: 'POST', headers: hdr, redirect: 'manual',
          body: 'form_type=customer&utf8=%E2%9C%93&contact%5Btags%5D=newsletter%2Cpopup&contact%5Bemail%5D=' + enc(email)
        });
        // 2) Kontakt-indsendelse, sender notifikations-mail til butikken (som den gamle popup)
        var notify = fetch('/contact', {
          method: 'POST', headers: hdr, redirect: 'manual',
          body: 'form_type=contact&utf8=%E2%9C%93&contact%5Bemail%5D=' + enc(email) + '&contact%5Bbody%5D=' + enc('Ny tilmelding via 15% popup. Email: ' + email)
        });
        Promise.allSettled([marketing, notify]).then(function (results) {
          var ok = results.some(function (res) {
            return res.status === 'fulfilled' && res.value && (res.value.type === 'opaqueredirect' || res.value.status < 400);
          });
          if (ok) { showSuccess(); } else { failGracefully(orig); }
        });
      });

      if (emailInput) {
        emailInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); submitBtn.click(); }
        });
      }
    }

    if (copyBtn && codeEl) {
      copyBtn.addEventListener('click', function () {
        var code = codeEl.textContent.trim();
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(function () {
            var origCopy = copyBtn.textContent;
            copyBtn.textContent = copyBtn.dataset.copied || 'Kopieret';
            setTimeout(function () { copyBtn.textContent = origCopy; }, 2200);
          });
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-pp-form]').forEach(function(form) {
      var pp = form.closest('.pp');
      if (!pp) return;
      var variantsScript = pp.parentElement.querySelector('[data-pp-variants-json]') || document.querySelector('[data-pp-variants-json]');
      if (!variantsScript) return;
      var variants;
      try { variants = JSON.parse(variantsScript.textContent); } catch(e) { return; }

      var selected = { 1: null, 2: null, 3: null };
      pp.querySelectorAll('.pp-pill.is-active').forEach(function(p) {
        var pos = parseInt(p.dataset.ppOptionPos);
        if (pos) selected[pos] = p.dataset.ppValue;
      });

      var priceEl = pp.querySelector('[data-pp-price]');
      var roastLbl = pp.querySelector('[data-pp-roast-label]');
      var roastDot = pp.querySelector('[data-pp-roast-dot]');
      var variantInput = pp.querySelector('[data-pp-variant-id]');
      var addBtn = pp.querySelector('[data-pp-add]');
      var qtyVal = pp.querySelector('[data-pp-qty-val]');
      var qtyInput = pp.querySelector('[data-pp-qty-input]');

      function fmt(cents) {
        return (cents / 100).toFixed(2).replace('.', ',') + ' kr';
      }

      function findVariant() {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (selected[1] !== null && v.option1 !== selected[1]) continue;
          if (selected[2] !== null && v.option2 !== selected[2]) continue;
          if (selected[3] !== null && v.option3 !== selected[3]) continue;
          return v;
        }
        return null;
      }

      function syncRoast() {
        var dot = pp.querySelector('[data-pp-roast-dot]');
        var lbl = pp.querySelector('[data-pp-roast-label]');
        var wrap = dot ? dot.closest('.pp-roast') : null;
        if (!dot || !lbl || !wrap) return;
        var val = (selected[1] + ' ' + (selected[2] || '') + ' ' + (selected[3] || '')).toLowerCase();
        var pos, txt;
        if (val.indexOf('espresso') !== -1) {
          pos = parseFloat(wrap.dataset.ppEspressoPos);
          txt = wrap.dataset.ppEspressoLbl;
        } else if (val.indexOf('filter') !== -1) {
          pos = parseFloat(wrap.dataset.ppFilterPos);
          txt = wrap.dataset.ppFilterLbl;
        } else {
          return;
        }
        if (!isNaN(pos)) dot.style.left = pos + '%';
        if (txt) lbl.textContent = txt;
      }

      function syncUI() {
        var v = findVariant();
        if (!v) return;
        variantInput.value = v.id;
        if (priceEl) {
          priceEl.classList.add('is-updating');
          setTimeout(function() {
            priceEl.textContent = fmt(v.price);
            priceEl.classList.remove('is-updating');
          }, 150);
        }
        if (addBtn) {
          addBtn.disabled = !v.available;
          var txt = addBtn.querySelector('.pp-btn-text');
          if (txt) txt.textContent = v.available ? (addBtn.dataset.tAdd || 'Tilføj til kurv') : (addBtn.dataset.tSoldout || 'Udsolgt');
        }
        syncRoast();
      }

      pp.querySelectorAll('.pp-pill').forEach(function(pill) {
        pill.addEventListener('click', function() {
          var pos = parseInt(pill.dataset.ppOptionPos);
          var val = pill.dataset.ppValue;
          pill.parentElement.querySelectorAll('.pp-pill').forEach(function(p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          selected[pos] = val;
          syncUI();
        });
      });

      var qty = 1;
      pp.querySelectorAll('[data-pp-qty]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          qty = Math.max(1, qty + parseInt(btn.dataset.ppQty));
          if (qtyVal) {
            qtyVal.style.opacity = '0';
            setTimeout(function() {
              qtyVal.textContent = qty;
              qtyVal.style.opacity = '1';
            }, 80);
          }
          if (qtyInput) qtyInput.value = qty;
        });
      });

      // Slider
      var slider = pp.querySelector('[data-pp-slider]');
      var slidesEl = pp.querySelector('[data-pp-slides]');
      var prevBtn = pp.querySelector('[data-pp-prev]');
      var nextBtn = pp.querySelector('[data-pp-next]');
      var thumbs = pp.querySelectorAll('[data-pp-thumb]');
      var cur = 0;
      var total = slidesEl ? slidesEl.children.length : 0;

      function goTo(i) {
        cur = Math.max(0, Math.min(i, total - 1));
        if (slidesEl) slidesEl.style.transform = 'translateX(-' + (cur * 100) + '%)';
        thumbs.forEach(function(t, ti) { t.classList.toggle('is-active', ti === cur); });
        if (prevBtn) prevBtn.classList.toggle('is-hidden', cur === 0);
        if (nextBtn) nextBtn.classList.toggle('is-hidden', cur === total - 1);
      }
      if (prevBtn) prevBtn.addEventListener('click', function() { goTo(cur - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goTo(cur + 1); });
      thumbs.forEach(function(t) {
        t.addEventListener('click', function() { goTo(parseInt(t.dataset.ppThumb)); });
      });

      // Touch swipe
      if (slider) {
        var tx = 0, dx = 0;
        slider.addEventListener('touchstart', function(e) { tx = e.touches[0].clientX; }, { passive: true });
        slider.addEventListener('touchmove', function(e) { dx = e.touches[0].clientX - tx; }, { passive: true });
        slider.addEventListener('touchend', function() {
          if (Math.abs(dx) > 40) goTo(cur + (dx < 0 ? 1 : -1));
          dx = 0;
        });
      }

      // AJAX add to cart
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        if (addBtn.disabled) return;
        addBtn.classList.add('is-added');
        addBtn.disabled = true;

        var btnText = addBtn.querySelector('.pp-btn-text');
        var origText = btnText ? btnText.textContent : '';
        var formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
        .then(function(r) {
          if (!r.ok) { return r.json().then(function(err) { throw err; }); }
          return r.json();
        })
        .then(function() {
          return fetch('/cart.js').then(function(r) { return r.json(); });
        })
        .then(function(cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          setTimeout(function() {
            addBtn.classList.remove('is-added');
            addBtn.disabled = false;
            qty = 1;
            if (qtyVal) qtyVal.textContent = '1';
            if (qtyInput) qtyInput.value = '1';
          }, 2200);
        })
        .catch(function(err) {
          addBtn.classList.remove('is-added');
          addBtn.disabled = false;
          if (btnText) {
            btnText.textContent = (err && err.description) ? err.description : (addBtn.dataset.tRetry || 'Prøv igen');
            setTimeout(function() { btnText.textContent = origText; }, 2400);
          }
        });
      });

      // Init
      syncUI();
      if (total > 0) goTo(0);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
